var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgFooterAppleIcon = function SvgFooterAppleIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 8.68729,
    height: 10.4107,
    viewBox: "0 0 8.68729 10.4107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.25588 5.53641C7.24374 4.22117 8.36041 3.5813 8.41148 3.55151C7.77906 2.65251 6.79883 2.52968 6.45437 2.51989C5.6311 2.43542 4.83252 3.0002 4.41315 3.0002C3.9854 3.0002 3.33959 2.52805 2.64355 2.54192C1.74787 2.55539 0.90995 3.061 0.450391 3.84615C-0.498025 5.44704 0.209311 7.79962 1.11797 9.09363C1.5725 9.72738 2.10363 10.435 2.79883 10.4101C3.47896 10.3828 3.73301 9.98733 4.55378 9.98733C5.367 9.98733 5.60557 10.4101 6.31458 10.3942C7.04452 10.3828 7.50408 9.75758 7.94271 9.11812C8.46798 8.39174 8.67892 7.67638 8.68729 7.63965C8.67013 7.63394 7.26969 7.11282 7.25588 5.53641Z",
    fill: "#97969A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91655 1.66864C6.28235 1.2226 6.53264 0.615791 6.46316 0C5.93371 0.0228524 5.27157 0.357069 4.89028 0.793306C4.55294 1.17772 4.25159 1.80779 4.32944 2.40032C4.92418 2.44358 5.53484 2.10773 5.91655 1.66864Z",
    fill: "#97969A"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgFooterAppleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/footer-apple-icon.a73456f5723d0605b3ead67470653f17.svg";